<template>
  <div class="row m-0 h-100">
    <div class="col-2 align-self-end">
      <center>
      <div class="rotate"><span class="gradient">LEADERBOARD</span></div>
      </center>
    </div>
    <div class="col-10 bg h-100">
      <div class="row m-0 mt-5">
        <div class="col-7 offset-1 ">
          <div class="row m-0">
            <div class="col-12 p-0">
              <h3>NAME</h3>
            </div>
            <div class="col-1 mt-3 mb-3 pt-1 pl-0 pr-0">
              <div class="border_white"></div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="row m-0">
            <div class="col-12 p-0">
              <h3>TIME COMPLETED</h3>
            </div>
            <div class="col-4 mt-3 mb-3 pt-1 pl-0 pr-0">
              <div class="border_white"></div>
            </div>
          </div>
        </div>
      </div>
      <leaderboard pos="1." :score="scores[0]"></leaderboard>
      <leaderboard pos="2." :score="scores[1]"></leaderboard>
      <leaderboard pos="3." :score="scores[2]"></leaderboard>
      <leaderboard pos="4." :score="scores[3]"></leaderboard>
      <leaderboard pos="5." :score="scores[4]"></leaderboard>
      <leaderboard pos="6." :score="scores[5]"></leaderboard>
      <leaderboard pos="7." :score="scores[6]"></leaderboard>
      <leaderboard pos="8." :score="scores[7]"></leaderboard>
      <leaderboard pos="9." :score="scores[8]"></leaderboard>
      <leaderboard pos="10." :score="scores[9]"></leaderboard>
      <div class="row m-0 mt-2">
        <div class="col-9 offset-1 pr-0">
          <button @click="start()" class="btn btn-gold w-100">Start</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeaderboardItems from './partials/LeaderboardItem.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Leaderboard',
  components: {
    'leaderboard': LeaderboardItems
  },
  computed: {
    ...mapGetters([
      'leaderboard'
    ]),
    scores () {
      let scores = []
      console.log('this.leaderboard', this.leaderboard)
      this.leaderboard.forEach(item => {
        let obj = {
          name: item.name,
          surname: item.surname,
          timeTaken: item.timeTaken
        }
        scores.push(obj)
      })
      for (let index = this.leaderboard.length; index < 10; index++) {
        let obj = {
          name: '',
          surname: '',
          timeTaken: ''
        }
        scores.push(obj)
      }
      return scores
    }
  },
  created () {
    console.log('scores', this.scores)
  },
  methods: {
    start () {
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  background: -webkit-linear-gradient(45deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 100%);
  background-size: cover;
}
.rotate {
  transform: rotate(270deg);
  font-size: 12.7vh;
  font-family: 'open-sans-bold';
  padding-left: 2vh;
  margin-left: 2vh;
}
.border_white {
  background: #fff;
  padding: 1px 0;
}
.abs {
  position: absolute;
  bottom: 3vh;
  width: 100%;
}
.btn-gold {
  border-radius: 0;
  background-color: rgb(185, 140, 96);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Leaderboard.vue